import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeLactoseFree: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1289 1.64834C6.28131 1.78857 6.2912 2.0258 6.15097 2.17821L6.13344 2.19728C5.99858 2.34386 6.00243 2.57047 6.14219 2.71239L6.16441 2.73495C6.57228 3.14913 6.58352 3.81046 6.18995 4.23825C5.58549 4.89527 5.25 5.75544 5.25 6.64821V13.4243C5.25 13.7695 5.52982 14.0493 5.875 14.0493H7.875C8.08211 14.0493 8.25 14.2172 8.25 14.4243C8.25 14.6314 8.08211 14.7993 7.875 14.7993H5.875C5.11561 14.7993 4.5 14.1837 4.5 13.4243V6.64821C4.5 5.56733 4.90618 4.52592 5.638 3.73046C5.76085 3.59692 5.75735 3.39049 5.63003 3.2612L5.60781 3.23864C5.18749 2.81183 5.17591 2.13033 5.58149 1.68948L5.59903 1.67042C5.73925 1.51801 5.97648 1.50812 6.1289 1.64834Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.151 1.67042C10.08 1.59324 9.97988 1.54932 9.875 1.54932H5.875C5.66789 1.54932 5.5 1.71721 5.5 1.92432C5.5 2.13142 5.66789 2.29932 5.875 2.29932H9.68348C9.74373 2.43581 9.71805 2.60045 9.60781 2.71239L9.58559 2.73495C9.17772 3.14913 9.16648 3.81046 9.56005 4.23825C10.1645 4.89527 10.5 5.75544 10.5 6.64821V13.4243C10.5 13.7695 10.2202 14.0493 9.875 14.0493L7.875 14.0493C7.66789 14.0493 7.5 14.2172 7.5 14.4243C7.5 14.6314 7.66789 14.7993 7.875 14.7993L9.875 14.7993C10.6344 14.7993 11.25 14.1837 11.25 13.4243V6.64821C11.25 5.56733 10.8438 4.52591 10.112 3.73046C9.98915 3.59692 9.99265 3.39049 10.12 3.2612L10.1422 3.23864C10.5625 2.81183 10.5741 2.13033 10.1685 1.68948L10.151 1.67042Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 7.42432C4.75 7.21721 4.91789 7.04932 5.125 7.04932H10.875C11.0821 7.04932 11.25 7.21721 11.25 7.42432C11.25 7.63142 11.0821 7.79932 10.875 7.79932H5.125C4.91789 7.79932 4.75 7.63142 4.75 7.42432Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 12.4243C4.75 12.2172 4.91789 12.0493 5.125 12.0493H10.875C11.0821 12.0493 11.25 12.2172 11.25 12.4243C11.25 12.6314 11.0821 12.7993 10.875 12.7993H5.125C4.91789 12.7993 4.75 12.6314 4.75 12.4243Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 3.42432C5.75 3.21721 5.91789 3.04932 6.125 3.04932H7.625C7.83211 3.04932 8 3.21721 8 3.42432C8 3.63142 7.83211 3.79932 7.625 3.79932H6.125C5.91789 3.79932 5.75 3.63142 5.75 3.42432Z"
        fill="black"
      />
    </svg>
  );
};

export default BadgeLactoseFree;
